import { useCallback, useEffect, useState } from 'react';
import { Button } from 'rsuite';
import { FaCog, FaWhatsapp, FaMagic, FaEye, FaEyeSlash, FaCommentDots } from 'react-icons/fa';
import { useAuth } from '../../../hooks/auth';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { getConnection } from '../../../services/uniservice/uniservice.service';
import OfficialTemplates from './OfficialTemplates';
import GenericMessages from './GenericMessages';
import NotificationConfigModal from './NotificationConfigModal';
import EmBreve from '../../../components/EmBreve';
import { temAcessoApiOficial } from '../../../config/apiOficialWhatsapp';
import { styles } from './styles';

const TABS = [
  { key: 'oficiais', label: 'Templates Oficiais', Icon: FaWhatsapp },
  { key: 'sistema', label: 'Templates do Sistema', Icon: FaMagic },
];

// Tela unificada "Templates de mensagens": duas tabs — Oficiais (Meta) e do
// Sistema (robô) — com prévia da mensagem em ambas (botão global) e as
// configurações de notificação da conexão num único lugar.
export default function TemplatesDeMensagens() {
  const { id_empresa } = useAuth();
  const { theme } = useCustomTheme();

  // Templates Oficiais (Meta) só para contratos liberados; os demais veem
  // "Em breve" e caem direto na tab do sistema.
  const apiOficialLiberada = temAcessoApiOficial(id_empresa);

  const [tab, setTab] = useState(apiOficialLiberada ? 'oficiais' : 'sistema');
  const [showPreview, setShowPreview] = useState(true);
  const [connection, setConnection] = useState(null);
  const [configOpen, setConfigOpen] = useState(false);

  const loadConnection = useCallback(async () => {
    if (!temAcessoApiOficial(id_empresa)) return;
    setConnection(await getConnection(id_empresa));
  }, [id_empresa]);

  useEffect(() => {
    loadConnection();
  }, [loadConnection]);

  return (
    <div style={styles.page(theme)}>
      <div style={styles.topbar(theme)}>
        <div style={styles.logo(theme)}><FaCommentDots size={16} /></div>
        <h1 style={styles.title(theme)}>Templates de mensagens</h1>
        <div style={styles.topActions}>
          {tab === 'oficiais' && apiOficialLiberada && (
            <Button appearance="ghost" onClick={() => setShowPreview((v) => !v)} startIcon={showPreview ? <FaEye /> : <FaEyeSlash />}>
              {showPreview ? 'Ocultar prévia' : 'Mostrar prévia'}
            </Button>
          )}
          {apiOficialLiberada && (
            <Button appearance="primary" startIcon={<FaCog />} onClick={() => setConfigOpen(true)} style={{ backgroundColor: theme.colors.primary }}>
              Configurações
            </Button>
          )}
        </div>
      </div>

      <div style={styles.tabsBar(theme)}>
        {TABS.map(({ key, label, Icon }) => (
          <button key={key} type="button" style={styles.tab(theme, tab === key)} onClick={() => setTab(key)}>
            <Icon size={14} /> {label}
            {key === 'oficiais' && !apiOficialLiberada && <span style={styles.soonBadge(theme)}>Em breve</span>}
          </button>
        ))}
      </div>

      <div style={styles.body}>
        {tab !== 'oficiais' ? (
          <GenericMessages />
        ) : apiOficialLiberada ? (
          <OfficialTemplates showPreview={showPreview} />
        ) : (
          <EmBreve
            titulo="Em breve"
            descricao="Os templates oficiais do WhatsApp (aprovados pela Meta) ainda estão em liberação e estarão disponíveis para a sua loja em breve. Enquanto isso, use os Templates do Sistema."
          />
        )}
      </div>

      <NotificationConfigModal
        open={configOpen}
        onClose={() => setConfigOpen(false)}
        companyId={id_empresa}
        connection={connection}
        onSaved={(saved) => setConnection(saved)}
      />
    </div>
  );
}
